import type { FC } from 'react';
import { useEffect, useContext } from 'react';
import AppContext from '../utils/appContext';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import BinBrowser from '../components/binbrowser';
interface BinProps {}
const Bin: FC<BinProps> = ({}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [folderPath, setFolderPath] = useState<string>('/');

  const context = useContext(AppContext);
  const navigate = useNavigate();

  //parse object to JSON

  const checkStatus = async () => {
    const storedJWT = localStorage.getItem('jwt');

    if (storedJWT) {
      await fetch(process.env.REACT_APP_API_URL + '/check-status.php', {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: 'Bearer ' + storedJWT,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data == 'success') {
            console.log('success');
            setLoading(false);
          } else {
            localStorage.clear();
            context?.updateLoginStatus(false);
            navigate('/login');
          }
        })
        .catch((error) => {
          // Handle network or server errors
          console.log('error');
          console.log(error);
          localStorage.clear();
          context?.updateLoginStatus(false);
          navigate('/login');
        });
    } else {
      console.log('not logged in');
      localStorage.clear();
      context?.updateLoginStatus(false);
      navigate('/login');
    }
  };
  const logout = () => {
    localStorage.clear();
    context?.updateLoginStatus(false);
    navigate('/login');
  };

  const updateFolder = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };
  const updateFolderPath = (path: string) => {
    setFolderPath(path);
  };
  useEffect(() => {
    checkStatus();
  }, []);

  return (
    <div className="p-3 md:pt-10 fade-in md:p-5 lg:pl-10 xl:pl-16">
      <BinBrowser />
    </div>
  );
};
export default Bin;
